module.exports = __webpack_public_path__ + "static/media/08-sock@3x.8ea3eb4a.webp";